import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import {Helmet} from "react-helmet";

class DemoTankView extends React.Component {
  state = {};
  constructor(props) {
    super(props);
		this.state = {
		  tabs: ["", "", ""],
		  tabPanel: ["", "", ""],
		  tabPanel0: "",
		  tabPanel1: "",
		  tabPanel2: "",
		  modal: false,
		  tankData: [],
		  iotHistoryData: [],
		  iotlevelData: [],
		  test: [],
		  deviceId: "",
		  capacity: "",
		  type: "",
		  shape: "",
		  height: "",
		  length: "",
		  width: "",
		};
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {}


  render() {

	
	const mystyle = {
	  marginRight: "5px"
    };
	const leveldev = {
	    backgroundColor: "white",
		padding: "10px"
	};
	const leveldevheadercolor = {
	    color: "red"
	};
	
	const wrapper = {
		backgroundColor: "#2d4e5a",
		height: "200px",
		width: "200px",
		position: "relative"
	}

    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "device_id",
        label: "Device Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "lower_kl",
        label: "Lower KL",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "higher_kl",
        label: "Higher KL",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "iot_curent_time",
        label: "Created",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

	const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      // selectableRows: "multiple",
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: true,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'IoT.csv',
      },
    };

    
		let dataArr1 = [			
			['3',"862549046138692","65","85","2020-11-07T12:24:01+00:00"],
			['2',"862549046138692","45","65","2020-11-07T12:24:01+00:00"],
			['3',"862549046138692","65","85","2020-11-07T12:24:01+00:00"],
			['4',"862549046138692","85","105","2020-11-07T12:24:01+00:00"],
			['5',"862549046138692","45","65","2020-11-07T12:24:01+00:00"],
			['6',"862549046138692","45","65","2020-11-07T12:24:01+00:00"],
			['7',"862549046138692","65","85","2020-11-07T12:24:01+00:00"],
			['8',"862549046138692","45","","2020-11-07T12:24:01+00:00"],
			['9',"862549046138692","105","120","2020-11-07T12:24:01+00:00"],
			['10',"862549046138692","45","65","2020-11-07T12:24:01+00:00"],
			['11',"862549046138692","","120","2020-11-07T12:24:01+00:00"],	
			['12',"862549046138692","45","","2020-11-07T12:24:01+00:00"],			
			['13',"862549046138692","65","85","2020-11-07T12:24:01+00:00"],
			['14',"862549046138692","45","65","2020-11-07T12:24:01+00:00"],
			['15',"862549046138692","105","120","2020-11-07T12:24:01+00:00"],			
		];
		
		return (
        <>
		<div style={{display: this.state.iotlevelData.lower_kl ? 'block' : 'none' },leveldev}>
			<div class="row">
				<div class="col-lg-7">
					<div class="row">
						<div style={{fontWeight: "900", color: "rgb(0 0 128)", fontSize: "30px", width: "100%", marginLeft: "10px", marginBottom: "30px"}}>Device Id: #862549046138692</div>
						<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(0 5 8)", width: "100%", fontSize: "25px" }}>TANK DETAILS</div>
					</div>
					<div class="row">
						<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(97, 111, 119)", fontSize: "16px", marginTop: "12px", marginLeft: "40px" }}>
							<div>
								<strong>Capacity : </strong>130<br />
								<strong>Type : </strong>Tank<br />
								<strong>Shape : </strong>Cuboid<br />
								<strong>Height : </strong>13<br />
								<strong>Length : </strong>37<br />
								<strong>Width : </strong>10<br />
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-5">
					<iframe src={'https://www.gowatr.com/waterlevel.html?fillvalue=6.5&klvalue=65&name1=S1&value1=12&typ1=Normal%20Level%201&name2=s2&value2=10.5&typ2=Normal%20Level%202&name3=s3&value3=8&typ3=Critical%20Level%201&name4=s4&value4=6.5&typ4=Critical%20Level%202&name5=s5&value5=4.5&typ5=Danger%20Level&name6=Start&value6=0&typ6=High'} width="335" height="315" frameBorder="0" scrolling="no"></iframe>
				</div>
			</div>
		</div>
          <div style={{ marginTop: "10px" }}>
            
            <MUIDataTable
              title={"IoT - Level Sensor"}
              data={dataArr1}
              columns={columns}
              options={options} />

          </div>
        </>
      );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(DemoTankView)
